import React, { useEffect, useState } from 'react'
import axios from 'axios'

import { tx } from '@transifex/native'
import useSWR from '../../../hooks/useSWR'
import { swalChoose, swalError, swalSuccess } from '../../../common/components/Swaler'
import ShowBatteryStatusModal from '../../Modals/ShowBatteryStatusModal'
import { sendToIframe } from '../../../common/utils'

const checkEditableCustomer = (editableCustomer, lockId, customerId) => editableCustomer && editableCustomer.lockId === lockId && editableCustomer.customerId === customerId

const iframeTitle = 'qlocx-app-2'

const Customers = ({ onControllerClick }) => {
  const [search, setSearch] = useState('')
  const [customer, setCustomer] = useState(null)
  const [editableOwner, setEditableOwner] = useState(null)
  const [editableCustomer, setEditableCustomer] = useState(null)
  const [showBatteryStatusModal, setShowBatteryStatusModal] = useState(false)
  const [lockId, setLockId] = useState(null)
  const [choosenController, setChoosenController] = useState(null)
  const [loggedInCustomerSession, setLoggedInCustomerSession] = useState(null)

  const { data: list } = useSWR(search.length > 2 && '/subject/admin/customers', { search })
  const { data: accesses, mutate: mutateAccessses } = useSWR(customer && `/subject/admin/customers/${customer._id}/accesses`)

  useEffect(() => {
    const handler = (event) => {
      try {
        const { name } = JSON.parse(event.data)

        if (name === 'loaded') {
          sendToIframe(
            {
              name: 'customer',
              authToken: loggedInCustomerSession.authToken,
              userType: loggedInCustomerSession.userType,
              locale: tx.getCurrentLocale(),
            },
            iframeTitle
          )
        }
      } catch {
        // ignore
      }
    }

    if (loggedInCustomerSession) window.addEventListener('message', handler)

    return () => window.removeEventListener('message', handler)
  }, [loggedInCustomerSession])

  useEffect(() => {
    if (choosenController !== null) {
      onControllerClick(choosenController)
    }
  }, [choosenController, onControllerClick])

  const submitUserUpdate = ({ _id, ...body }) => {
    if (body.password && body.password.length < 8) return swalError('Ajdå', 'Lösenord måste vara minst 8 tecken')

    axios
      .put(`/subject/admin/customers/${_id}`, body)
      .then(() => {
        swalSuccess('Sparat!', '', 'OK')
        if (_id === customer._id) setEditableCustomer(null)
        if (editableCustomer) setEditableCustomer(null)
      })
      .catch((e) => {
        swalError('Fel', e.message)
      })
  }

  const deleteCustomer = (id) =>
    swalChoose('Säker?', `Vill du verkligen radera ${customer.name}?`, ['Ja', 'Avbryt']).then((r) => {
      if (r.dismiss) return

      axios
        .delete(`/subject/admin/customers/${id}`)
        .then(() => {
          swalSuccess('Raderat!', '', 'OK')
          setSearch('')
          if (id === customer._id) setCustomer(null)
          if (editableCustomer) setEditableCustomer(null)
        })
        .catch((e) => {
          swalError('Fel', e.message)
        })
    })

  const loginAsCustomer = (id) => {
    axios.post(`/subject/admin/customers/${id}/login`).then(({ data: { authToken } }) => {
      setLoggedInCustomerSession({
        iframeSrc: 'https://app.qlocx.com',
        authToken,
        userType: 'customer',
      })
    })
  }

  const switchOwner = () => {
    if (!editableOwner) return

    const [accessId, customerId] = editableOwner.split('-')

    axios.put(`/subject/admin/locks/${accessId}/owner`, { _id: customerId }).then(() => {
      swalSuccess('Uppdaterat!', '', 'OK')
      setEditableOwner(null)
      mutateAccessses((prev) =>
        prev.map((a) => {
          if (a._id !== accessId) return a

          const foundUser = a.users.find((u) => u._id === customerId)

          return { ...a, owner: foundUser }
        }))
    })
  }

  return (
    <div>
      {showBatteryStatusModal && <ShowBatteryStatusModal setShowBatteryStatusModal={setShowBatteryStatusModal} lockId={lockId} setLockId={setLockId} choosenController={choosenController} setChoosenController={setChoosenController} />}
      <br />
      <input
        type="text"
        placeholder="Telefonnummer eller email"
        value={search}
        onChange={(e) => {
          if (customer) setCustomer(null)
          setSearch(e.target.value)
        }}
      />
      <br />
      <div className="flex" style={{ justifyContent: 'start' }}>
        {list?.map((c) => (
          <div key={c._id} style={{ background: '#fff', cursor: 'pointer' }} onClick={() => setCustomer(c)}>
            {`${c.name} ${c.surname || ''}, ${c.phone}, ${c.email}`}
          </div>
        ))}
      </div>
      {accesses && (
        <div>
          <br />
          <p>{`Ändra ${customer.name || 'Okänd'}s uppgifter`}</p>
          <div>
            <span>
              <input type="text" value={customer.name} onChange={(e) => setCustomer({ ...customer, name: e.target.value })} />
              <input type="text" value={customer.surname} onChange={(e) => setCustomer({ ...customer, surname: e.target.value })} />
              <input type="text" value={customer.email} onChange={(e) => setCustomer({ ...customer, email: e.target.value })} />
              <input type="text" value={customer.phone} onChange={(e) => setCustomer({ ...customer, phone: e.target.value })} />
              <input type="password" value={customer.password || ''} onChange={(e) => setCustomer({ ...customer, password: e.target.value })} placeholder="Lösenord" />
              <button onClick={() => submitUserUpdate(customer)}>Uppdatera</button>
              <button style={{ background: 'red' }} onClick={() => deleteCustomer(customer._id)}>
                Radera
              </button>
            </span>
          </div>
        </div>
      )}
      <hr style={{ border: '2px solid #fff' }} />
      {customer && (
        <button style={{ background: 'green', color: 'white' }} onClick={() => loginAsCustomer(customer._id)}>
          Logga in som användare
        </button>
      )}

      {loggedInCustomerSession && (
        <div>
          <br />
          <iframe title={iframeTitle} src={loggedInCustomerSession.iframeSrc} width="375" height="812" style={{ border: 'none' }} />
        </div>
      )}

      <hr style={{ border: '2px solid #fff' }} />
      <div className="flex" style={{ alignItems: 'flex-start' }}>
        {accesses?.map((a) => (
          <div style={{ padding: 30 }} key={a._id}>
            <h4
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setShowBatteryStatusModal(true)
                setLockId(a._id)
              }}
            >
              {a.custom_name}
            </h4>
            <div>
              <p>{`Sätt ansvarig för ${a.custom_name}`}</p>
              <div>
                <select value={editableOwner || `${a._id}-${a.owner?._id}`} onChange={(e) => setEditableOwner(e.target.value)}>
                  {a.users.map((u) => (
                    <option value={`${a._id}-${u._id}`}>{`${u.name} ${u.surname || ''}`}</option>
                  ))}
                </select>
                <div style={{ cursor: 'pointer' }} onClick={switchOwner}>
                  Spara
                </div>
              </div>
              <br />
              <br />
            </div>
            <div>
              {a.users.map((u) =>
                checkEditableCustomer(editableCustomer, a._id, u._id) ? (
                  <div>
                    {`${u.name || 'Okänd'} ${u.surname || ''}`}
                    <span>
                      <input type="text" value={editableCustomer.phone} onChange={(e) => setEditableCustomer({ ...editableCustomer, phone: e.target.value })} />
                      <button onClick={() => submitUserUpdate({ _id: u._id, phone: editableCustomer.phone })}>Uppdatera</button>
                    </span>
                  </div>
                ) : (
                  <div style={{ background: '#fff', cursor: 'pointer' }} onClick={() => setEditableCustomer({ lockId: a._id, customerId: u._id, phone: u.phone })}>
                    {`${u.name || 'Okänd'} ${u.surname || ''}, ${u.phone}`}
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default Customers
